<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >     
  <v-tabs
    centered
    color="primary"
    dark
    icons-and-text
  >
    <v-tabs-slider color="white"></v-tabs-slider>

    <v-tab href="#tab-1">
      New Orders
    </v-tab>

    <v-tab href="#tab-2" @change="$refs.delivered.loadDelivered()">
      Delivered Orders
      
    </v-tab>

    <v-tab href="#tab-3" @change="$refs.cancelled.loadCancelled()">
      Cancelled Orders
      
    </v-tab>

    <v-tab-item
      value="tab-1"
    >
      <neworders></neworders>
    </v-tab-item>
    <v-tab-item
      value="tab-2"
      
    >
      <delivered-orders ref="delivered"></delivered-orders>
    </v-tab-item>
    <v-tab-item
      value="tab-3"
    >
      <cancelled-orders ref="cancelled"></cancelled-orders>
    </v-tab-item>
  </v-tabs>
</v-flex>
</v-layout>
</v-container>
</template>
<style>
.orders-table {border: 1px solid #dddddd;}
.orders-table td table{border-collapse: collapse;}
.orders-table td table td{border: 1px solid #dddddd;}
.orders-table table tr th + th { border-left:1px solid #dddddd; }
.orders-table table tr td + td { border-left:1px solid #dddddd; }
</style>
<script>
import neworders from './Orders/new-orders'
import deliveredOrders from './Orders/delivered-orders'
import cancelledOrders from './Orders/cancelled-orders'
  export default {
    data () {
      return {
        orderState:0
      }
    },
    components:{
      neworders,
      deliveredOrders,
      cancelledOrders
    },
    methods:{
      
    }
  }
</script>